var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.846313H24V17.1537H0V0.846313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.846313H24V6.28208H0V0.846313Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7179H24V17.1537H0V11.7179Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.3077,
    fill: "white",
    transform: "translate(0 0.84613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLu);
export default __webpack_public_path__ + "static/media/LU.8f203df07c65962c9a3f3fb96e310e54.svg";
export { ForwardRef as ReactComponent };